<template>
  <section id="share" class="module">
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <div class="row">
            <div class="col-sm-8">
              <h2>Share with your friends &amp; invite them to vote!</h2>
            </div>
            <div class="col-xs-12 col-sm-2 share-btn">
              <div class="facebook-this">
                <a :href="facebookLink" target="_blank" class="gradient-1"><i class="fa fa-facebook" aria-hidden="true"></i> Share</a>
              </div>
            </div>

            <div class="col-xs-12 col-sm-2 share-btn">
              <div class="tweet-this">
                <a :href="twitterLink" class="meta-act-link meta-tweet gradient-1" target="_blank"><i class="fa fa-twitter" aria-hidden="true"></i> Share</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {facebookShareLink, twitterShareLink} from '@/utils/share'

export default {
  data () {
    return {
      facebookLink: facebookShareLink(this.$route.path),
      twitterLink: twitterShareLink('Check out the Best of Sacramento', this.$route.path)
    }
  },
  props: {
    project: {
      type: Object,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/_site_variables.scss';
  @import '@/assets/scss/partials/_mixins.scss';

  #share {
    color: $font-light;
    background: #000;
    padding: 80px 0 60px 0;

    h2 {
      color: $font-light;
      margin: 0;
    }
  }

  .share-btn {
    margin: 25px auto 0;
    padding: 5px;

    a {
      background-color: #fff;
      border-radius: 15px;
      color: $share-fontcolor;
      display: block;
      font-family: $default-font-primary;
      font-size: 1.2em;
      font-weight: 700;
      padding: 10px 15px;
      text-align: center;
      text-transform: normal;
      width: 100%;

      i {
        padding-right: 5px;
        font-weight: 300;
        font-size: 120%;
        vertical-align: middle;
      }

      &:hover {
        color: $brand-tertiary;
        text-shadow: 1px 1px 2px #000;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Share.vue